"use client"

import { normalizeTextEncoding } from "@/lib/util/text-encoding"
import { useTranslation } from "react-i18next"

export default function HomeProductsGridTitle() {
  const { t } = useTranslation()

  return (
    <h2 className="text-2xl font-extrabold tracking-tight text-slate-800 md:text-3xl">
      {normalizeTextEncoding(t("home.homeProducts"))}
    </h2>
  )
}
